import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
//import { selectAddress, selectAddressShort, selectNftSelected } from '../../store/userStore';
import { Button } from '../common';
import { PlayGame } from '../PlayGame';
import { IMenuHeaderProps } from './MenuHeader';
import audioVibes from '../../game/SpeedDegen.mp3';
import mutedImg from './Resources/muted.png';
import unmutedImg from './Resources/unmuted.png';

// TODO: toggle change image on/off
// TODO: change localStorage to redux for music component
let audio = new Audio(audioVibes);
let isMusicOffValue: boolean = false;
let muted: boolean = true;
let volumeBefore: number = 0.2;

export const MenuMusic = (props: IMenuHeaderProps) => {
  const [volume, setVolume] = useState<number>(0);

  const toggleMusicMenu = useCallback(() => {
    let isMusicOn: boolean = !(localStorage.getItem('isPlayingMusic') === 'true');
    if (volume != 0) volumeBefore = volume;

    if (isMusicOn == true) {
      setVolume(volumeBefore);
      audio.play();
      isMusicOffValue = false;
      muted = false;
    } else if (isMusicOn == false) {
      audio.pause();
      isMusicOffValue = true;
      muted = true;
      setVolume(0);
    }
    localStorage.setItem('isPlayingMusic', isMusicOn.toString());
    return isMusicOffValue;
  }, []);

  const playMusic = (audio: any, volume: number) => {
    audio.setAttribute('loop', 'loop');
    audio.volume = volume;

    if (volume == 0) {
      muted = true;
    } else {
      muted = false;
      volumeBefore = volume;
    }
    audio.play();
  };

  return (
    <div className="music-container">
      {playMusic(audio, volume)}
      <div className="music-container-column">
        <div className="music-img-container" /*onClick={toggleMusicMenu}*/>
          {isMusicOffValue || muted ? <img alt="muted" src={mutedImg} /> : <img alt="volume on" src={unmutedImg} />}
          <div className="music-dropdown">
            <div className="music-drop-container">
              <div className="music-drop-degen">Audio</div>
              <div className="music-drop-wallet">
                <div className="player">
                  <input
                    type="range"
                    min={0}
                    max={1}
                    step={0.02}
                    value={volume}
                    onChange={(event) => {
                      audio.volume = event.currentTarget.valueAsNumber;
                      if (audio.volume == 0) {
                        muted = true;
                        isMusicOffValue = true;
                      } else {
                        muted = false;
                        isMusicOffValue = false;
                        volumeBefore = audio.volume;
                      }
                      setVolume(audio.volume);
                    }}
                  />
                  <Button className="btn-anchor" label={'Toggle Music'} onClick={toggleMusicMenu} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="music-actions">
          <div className="music-degen-selected">Audio</div>
        </div>
      </div>
    </div>
  );
};
